import React from "react";
import LeftHero from "./LeftHero";
import "./HeroExperienceSection.css";

interface CardItem {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  description: React.ReactNode;
}

interface HeroExperienceSectionProps {
  title: string;
  subtitle: string;
  highlight?: string;
  primaryBtn?: { label: string; link?: string };
  secondaryBtn?: { label: string; link?: string };
  cards: CardItem[];
}

const HeroExperienceSection: React.FC<HeroExperienceSectionProps> = ({
  title,
  subtitle,
  highlight,
  primaryBtn,
  secondaryBtn,
  cards,
}) => {
  return (
    <section className="hero-experience">
      {/* === LEFT SIDE (Dynamic via LeftHero) === */}
      <LeftHero
        title={title}
        subtitle={subtitle}
        highlight={highlight}
        primaryBtn={primaryBtn}
        secondaryBtn={secondaryBtn}
      />

      {/* === RIGHT SIDE (Dynamic Cards) === */}
      <div className="experience-visual">
        <div className="cards-grid">
          {cards.map((card, index) => (
            <div className="exp-card" key={index}>
              <h3>{card.title}</h3>
              {card.subtitle && <p>{card.subtitle}</p>}
              <span>{card.description}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroExperienceSection;
